<h6 id="table_manutenzioniOperaList">Elenco manutenzioni</h6>
<div style="transform: rotateX(180deg);" class="table-responsive mb-3">
    <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_documentoOperaList">
        <thead class="thead-light">
            <tr>
                <th scope="col">ID</th>
                <th scope="col">Tipo intervento</th>
                <th scope="col">Data prevista</th>
                <th scope="col">Ente manutentore</th>
                <th scope="col">Data esecuzione</th>
                <th scope="col">Data prossima manutenzione</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items">
                <td>{{ item.idInterventoManutenzione }}</td>
                <td>{{ item.idTipoIntervento | anagraficaTipologiaIntervento: (datalist.tipologiaIntervento || []) }}</td>
                <td>{{ item.dataPrevista | date: 'dd/MM/yyyy' }}</td>
                <td>{{ item.enteManutentore }}</td>
                <td>{{ item.dataEsecuzione | date: 'dd/MM/yyyy' }}</td>
                <td>{{ item.dataProssimaManutenzione | date: 'dd/MM/yyyy' }}</td>
                <td class="actions">
                    <button aria-label="visualizza dettagli" type="button" (click)="viewItem(item)" class="btn btn-xs btn-link" container="body" ngbTooltip="Visualizza dettagli">
                        <app-toolkit-bl-icon icon="search" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="modifica" *ngIf="canEdit" type="button" container="body" (click)="editItem(item)" class="btn btn-xs btn-link" ngbTooltip="Modifica">
                        <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="elimina" *ngIf="canEdit" class="btn btn-xs btn-link" container="body" (click)="deleteItem(item.idInterventoManutenzione)" ngbTooltip="Elimina">
                        <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="!items.length">
                <td colspan="7"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
            </tr>
        </tbody>
    </table>
</div>
<div *ngIf="canEdit" class="button-actions">
    <button type="button" class="btn btn-outline-primary" (click)="addItem()">
        <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
        Aggiungi
    </button>
</div>